module.exports = __webpack_public_path__ + "static/media/Normas_oral_IIIMostra.ef41e6cf.pdf";